import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower } from '@btime/helpers'
import React from 'react'

import { SmallText, Text } from '../../../../components/presentation/Text'
import { useOpenServiceOrderModal } from '../../../../utils/routes/modals/modalsActions'
import DateTimeIcons from '../../../../components/presentation/DateTimeIcons'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Icon from '../../../../components/shapes/Icon'
import Link from '../../../../components/actions/Link'
import Panel from '../../../../components/structure/Panel'
import StatusTag from '../../../../containers/serviceOrders/StatusTag'

const ActionPlanCard = ({ actionPlan }) => {
  const openModal = useOpenServiceOrderModal()

  const { reply } = actionPlan
  const checklistName = capitalizeAllIfLower(actionPlan.checklist.name)
  const responsibleName = capitalizeAllIfLower(actionPlan.user?.name || actionPlan.userGroup?.name)

  return (
    <Panel lineBorder mediumPadding borderLeftColor={COLORS.purple}>
      <FlexGrid justify="space-between" align="flex-start">
        <div>
          <Text bold>{checklistName}</Text>
          <SmallText size="xsmall">Responsável: {responsibleName}</SmallText>
        </div>
        <Link block onClick={() => openModal(actionPlan)}>
          <Icon name="BsSearch" color={COLORS.dark3} />
        </Link>
      </FlexGrid>

      <FlexGrid gutter={0.5} justify="flex-start">
        <StatusTag item={actionPlan.status} />
        <DateTimeIcons date={actionPlan.insertedAt} gutter={0.5} />
      </FlexGrid>
    </Panel>
  )
}

export default ActionPlanCard
